import { Link } from "react-router";

import VisibilityIcon from "@mui/icons-material/Visibility";

const ViewButton = ({ companyId }) => {
	return (
		<Link to={`/admin/company/${companyId}`}>
			<VisibilityIcon sx={{ color: "#8dd3b5" }} />
		</Link>
	);
};

export default ViewButton;
